<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">

      <!-- <app-breadcrumb></app-breadcrumb> -->

      <h1 class="ui block header"> Frequently asked questions </h1>

      <div class="ui basic segment">
        <ol class="ui very relaxed divided list">
          <li class="item">
            <h4 class="header">
              <b>Who are accredited agents?</b>
            </h4> Accredited agents are person(s) or institutions certified by the corporate affairs commission to
            process and submit
            pre-incorporation and post-incorporation filings on-behalf of individuals and businesses.
          </li>
          <li class="item">
            <h4 class="header">
              <b>I have forgotten my Password, What can I do?</b>
            </h4> On the Login prompt; use the forgot password feature; this would send you an electronic mail
            notification on further
            steps to take to reset your password or get a new one
          </li>
          <li class="item">
            <h4 class="header">
              <strong>What do I do If I do not receive my password after account creation?</strong>
            </h4> Go to the 'Sign in' page and click 'Forgot Password' link and follow the instructions. An email
            containing a password
            reset link will be sent to your registered email address. Click on the link or paste it on your browser and
            follow
            the steps provided.
          </li>
          <li class="item">
            <h4 class="header">
              <b>What does CAC-CRP mean?</b>
            </h4> This stands for the Corporate Affairs Commission - Company Registration Portal.
          </li>
          <li class="item">
            <h4 class="header">
              <b>How can I get a CAC-CRP Portal Account Access?</b>
            </h4> It is easy as visiting
            <a href="http://services.cac.gov.ng/">services.cac.gov.ng</a> and clicking 'Create Account'
            button; fill in the form, submit and your account details would
            be sent to the email address you entered.
          </li>
          <li class="item">
            <h4 class="header">
              <b>What can I do with my CAC-CRP Portal Account?</b>
            </h4> With your CAC-CRP portal account you can submit pre-incorporation and post-incorporation filings with
            the Corporate
            Affairs Commission online in real time. You can also conveniently make payment for these filings from the
            comfort
            of your home; 24/7 a year.
          </li>
          <li class="item">
            <h4 class="header">
              <b>What is the first thing I must do to register a business in Nigeria?</b>
            </h4> To register a business in Nigeria; you would need to conduct a name search of the business. You can
            achieve this
            using your CAC-CRP account
          </li>
          <li class="item">
            <h4 class="header">
              <b>What do I need to submit a successful Name Availability Request?</b>
            </h4> To submit a name availability request successfully; you would need the following:
            <div class="description">
              <div class="list">
                <div style="border:none; padding:5px 0;"> The name(s) to search; a maximum of two
                  options</div>
                <div style="border:none; padding:5px 0;"> Your CAC-CRP account access (username and
                  password)</div>
                <div style="border:none; padding:5px 0;"> N500 only</div>
                <div style="border:none; padding:5px 0;"> Other required information about the type of
                  business (Please use an accredited agent if in doubt)</div>
              </div>
            </div>
          </li>
          <li class="item">
            <h4 class="header">
              <b>But I don't have an e-payment credit/debit card; how can I pay online?</b>
            </h4> If you do not have a debit/credit card to use for payment online; you can still use your internet
            banking to pay
            for fees in the CAC-CRP. If you don't have internet banking either; just generate the bill from the CAC-CRP;
            walk
            into any bank branch in Nigeria and make the payment.
          </li>
          <li class="item">
            <h4 class="header">
              <b>But I am outside Nigeria how am I affected?</b>
            </h4> This service is available for anybody to use from anywhere in the world at any point in time. Payment
            options available
            though are debit/credit cards as well as internet banking with any of the Nigerian banks.
          </li>
          <li class="item">
            <h4 class="header">
              <b>How will I know if My Name Availability Was Approved or Declined?</b>
            </h4> Once your name search request has been processed; you would receive an email notification in your
            officially registered
            email address. Then on logging in to your CAC-CRP account; you would be able to see the status of your
            application
            as well as generate the availability approval/disapproval form.
          </li>
          <li>
            <h4 class="header">
              <b>What do I do if My Name Availability request is declined?</b>
            </h4> You can seek advice from an accredited agent; or make another name search application.
          </li>
          <li class="item">
            <h4 class="header">
              <b>What is the Closest CAC office to me?</b>
            </h4> Please check the CAC official website at
            <a href="http://www.cac.gov.ng/">www.cac.gov.ng</a> for information on offices Nationwide
          </li>
          <li class="item">
            <h4 class="header">
              <b>Where can I get more information?</b>
            </h4> Please check the CAC official website at
            <a href="http://www.cac.gov.ng/">www.cac.gov.ng</a> for information
          </li>
        </ol>
      </div>

    </div>
  </div>
</div>
